// extracted by mini-css-extract-plugin
module.exports = {"fadeUp":"Animations--fadeUp--3Xb2k"};